import React, { useEffect, useState } from 'react'
import { AutoComplete, Input } from 'antd'
import { get } from '../../Common/api'
import { Color } from '../../Common/Color'

const highlight = (text, highlight) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
  return <span> {parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: Color.red } : {}}>
      {part}
    </span>)
  } </span>
}

const renderItem = (e, search) => ({
  value: `${e.normalized_name} ${e.zip_code}`,
  key: e.id,
  extra: e,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {highlight(e.normalized_name, search)}
      <span> {highlight(e.zip_code, search)} </span>
    </div>
  )
})

export default function ZipCodeSearchField ({ form, initialPostalPlace = null }) {
  const [options, setOptions] = useState([])
  const [inputValue, setInputValue] = useState(
    initialPostalPlace ? `${initialPostalPlace.normalized_name} ${initialPostalPlace.zip_code}` : ''
  )

  useEffect(() => {
    if (initialPostalPlace) {
      handleSearch(initialPostalPlace.zip_code)
    }
  }, [initialPostalPlace])

  const handleSearch = (search, callback) => {
    get({
      url: 'public/postal_places',
      params: { search },
      onSuccess: (json) => {
        const newOptions = json.map((e) => renderItem(e, search))
        setOptions(newOptions)
        if (callback) {
          callback(json)
        }
      }
    })
  }

  const onSelect = (value) => {
    const option = options.find((o) => o.value === value)
    form.setFieldValue('postal_place_id', option.extra.id)
    setInputValue(value)
  }

  return (
    <>
      <AutoComplete
        style={{ minWidth: '13.7em' }}
        popupMatchSelectWidth={350}
        options={options}
        showSearch={{ onSearch: handleSearch }}
        onSelect={onSelect}
        value={inputValue}
        onChange={setInputValue}
      />
      <Input type='hidden' />
    </>
  )
}
